import api from "src/api/index";

export  async function getProductHintsWithGroup(name) {
    if (!name?.trim()) {
        return
    }
    const hintsForm = new FormData()
    hintsForm.append("name", name)
    return await api.post("hints-product-with-groups", hintsForm)
}